// Barra de impersonación con cristal líquido y borde visible
// Comentarios en castellano

import React from "react";
import useAuth from "../../../hooks/useAuth";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";

export default function AdminBar() {
    const { auth, login } = useAuth();

    const handleExitUser = async () => {
        await login({
            primaryUser: auth?.secondaryUser,
            secondaryUser: auth?.secondaryUser,
            backImpersonate: true
        });
    };

    const isAdminImpersonating =
        auth?.secondaryUser?.role === "ROLE_ADMIN" &&
        auth?.secondaryUser?.idUser !== auth?.primaryUser?.idUser;

    if (!isAdminImpersonating) return null;

    return (
        <Paper
            elevation={0}
            sx={{
                position: "fixed",
                bottom: 24,
                right: 24,
                padding: "12px 10px 12px 20px",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                gap: 2,
                zIndex: 9999,

                // Liquid glass
                background: "rgba(255, 255, 255, 0.18)",
                backdropFilter: "blur(18px)",
                WebkitBackdropFilter: "blur(18px)",

                // Borde más visible para separar del fondo blanco
                border: "2px solid rgba(0,0,0,0.25)",

                // Texto siempre visible
                color: "#111"
            }}
        >
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
                Estàs impersonant un usuari
            </Typography>

            <button
                onClick={handleExitUser}
                type="button"
                style={{
                    cursor: "pointer",
                    backgroundColor: "#1976d2", // Blau MUI
                    color: "#fff",
                    border: "none",
                    borderRadius: "10px",
                    padding: "8px 18px",
                    fontWeight: 600,
                    fontSize: "14px",
                    transition: "all .25s ease",
                    outline: "none"
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#423edb";
                    e.currentTarget.style.boxShadow = "0 0 10px rgba(21,101,192,0.4)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#423edb";
                    e.currentTarget.style.boxShadow = "none";
                }}
            >
                Volver al administrador
            </button>

        </Paper>
    );
}
